module.exports = __webpack_public_path__ + "media/images/menu/crux-bd25b5bdfc316234d093bf5c3834d0f2.jpg";